module.exports = __webpack_public_path__ + "static/machine.9097eace.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/background/machine.svg
// module id = 684
// module chunks = 213534597649335